import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import './styles.css';

import i18n from './i18n';

import './assets/fonts/casa-listings-icons/style.css';
import store from './store/configure-store';

import Navigation from './navigation';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Navigation />
      </Provider>
    </I18nextProvider>
  );
}

export default App;
